module.exports = __webpack_public_path__ + "img/lsdzfwImg.64ee7803.png";